







































import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../../store/index';

export default Vue.extend({
  name: 'SimilarListDetails',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo,
    checkText: (state: any) => store.getters.getCheckText
  }),
  watch: {
    checkInfo(newVal, oldVal) {
      this.initSimilarChart();
      this.initHitDetailInfoList();
    },
    checkText(newVal, oldVal) {
      this.initSimilarChart();
    }
  },
  data() {
    return {
      checkTextStr: '',
      similarList: [],
      pageHitDetailInfoList:[]
    };
  },
  mounted() {
    if (this.checkInfo.hitDetailInfoList && this.checkText) {
      this.initSimilarChart();
      this.initHitDetailInfoList();
    }
  },
  methods: {
    // 将已标记的原文片段及相似片段
    initHitDetailInfoList(){
      this.pageHitDetailInfoList = this.checkInfo.hitDetailInfoList;
      this.pageHitDetailInfoList.forEach((item: any, index: number)=>{
        item.markOriginal = this.markOriginal(item,index);
        item.markSimilar = this.markSimilar(item,index);
      })
    },
    currentStyle(item: any) {
      const width = (item.length / this.checkInfo.reportModel.textLength) * 100 + '%';
      const left = (item.beginPosition / this.checkInfo.reportModel.textLength) * 100 + '%';
      return {
        width,
        left,
        'min-width': '1px',
        'position': 'absolute',
        'z-index': 99,
        'background-color': '#FF7272'
      };
    },
    // 标记charts图表优化，分片
    divideChartSection(list: any) {
      const section: any = [];
      list.forEach((item: any, index: number) => {
        if (section.length && (item.beginPosition - (section[section.length - 1].length + section[section.length - 1].beginPosition) === 0)) {
          section[section.length - 1].length = section[section.length - 1].length + item.length;
        } else {
          section.push({
            beginPosition: item.beginPosition,
            length: item.length
          });
        }
      });
      return section;
    },
    // 初始化相似片段分布图
    initSimilarChart() {
      this.similarList = [];
      const problemList = this.divideChartSection(this.checkInfo.hitDetailInfoList || []);
      problemList.forEach((item: any, index: number) => {
        const width = (item.length / this.checkInfo.reportModel.textLength) * 100 + '%';
        const left = (item.beginPosition / this.checkInfo.reportModel.textLength) * 100 + '%';
        this.$set(this.similarList, index, {
          width,
          left,
          'background-color': '#ccc',
          'min-width': '1px'
        });
      });
      return this.similarList;
    },
    // 标记字的索引信息转成段落
    divideSection(list: number[]) {
      const section: any = [];
      list.forEach((item: number, index: number) => {
        if (section.length && (list[index] - section[section.length - 1].beginIndex) === 1) {
          section[section.length - 1].beginIndex = list[index];
          section[section.length - 1].length = section[section.length - 1].length + 1;
        } else {
          section.push({
            beginIndex: list[index],
            begin: list[index],
            length: 1
          });
        }
      });
      // section.sort((a:any,b:any)=>{ return a.begin - b.begin;})
      return section;
    },
    // 标记原文片段
    markOriginal(item: any, index: number) {
      let checkText = this.checkText.substr(item.beginPosition, item.length) || '';
      const section = this.divideSection(item.originalChars);
      // 按字标记
      const checkTextArry = checkText.split('');
      let hitStr = '';
      let flag = false;
      checkTextArry.forEach((items:any,index1:number)=>{
        // 标注颜色
        let eClass = 'red border-b-red';
        // 根据不同的状态显示不同的颜色
        if (item.isSelfCited) {
          eClass = 'yellow border-b-yellow';
        } else if (item.isReference) {
          eClass = 'green border-b-green';
        } else if(item.isLaw) {
          eClass = 'deepblue border-b-deepblue';
        }
        if (item.originalChars.indexOf(item.beginPosition + index1) != -1){
          if(flag) {
            hitStr +=  checkTextArry.length-1 === index1?`${items}</span>`:items;
          }else {
            hitStr += `<span data-index="${index1}" class="${eClass}">${items}`;
            checkTextArry.length-1 === index1?hitStr+='</span>':hitStr;
            flag = true;
          }
        }else{
          if(flag){
            hitStr +=  `</span>${items}`;
            flag = false;
          }else {
            hitStr += items;
          }
        }
      })
      let offset = 0;
      // section.forEach((items: any) => {
      //   const hitWord = checkText.substr(items.begin - item.beginPosition - offset, items.length);
      //   checkTextArry.splice(items.begin - item.beginPosition - offset, items.length, `<span data-index=${index} class="red border-b-red">${hitWord}</span>`);
      //   // 按字标的偏移量
      //   offset = offset + items.length - 1;
      // });
      // checkText = checkTextArry.join('');
      // 截取前20个字符和后20个字符
      const frontStr = item.beginPosition>20?this.checkText.substr(item.beginPosition - 20, 20):'';
      const afterStr = this.checkText.substr(item.beginPosition + item.length, 20);
      hitStr = frontStr + hitStr + afterStr;
      return hitStr.replace(/\r\n/g, '<br />').replace(/\r/g, '<br />').replace(/\n/g, '<br />');
    },
    // 标记相似片段
    markSimilar(item: any, index: number) {
      let checkText = item.hitText || '';
      if (!item.hasCopyRight) {
        return '';
      }
      // const section = this.divideSection(item.similarChars);
      // 按字标记
      const checkTextArry = checkText.split('');
      let hitStr = '';
      let flag = false;
      checkTextArry.forEach((items:any,index:number)=>{
        if (item.similarChars.indexOf(item.hitBeginPosition + index) != -1){
          if(flag) {
            hitStr +=  items;
          }else {
            hitStr += '<span class="red border-b-red">' + items;
            flag = true;
          }
        }else{
          if(flag){
            hitStr +=  '</span>' + items;
            flag = false;
          }else {
            hitStr += items;
          }
        }
      })
      // let offset = 0;
      // section.forEach((items: any) => {
      //   const hitWord = checkText.substr(items.begin - item.hitBeginPosition - offset, items.length);
      //   checkTextArry.splice(items.begin - item.hitBeginPosition - offset, items.length, `<span data-index=${index} class="red border-b-red">${hitWord}</span>`);
      //   // 按字标的偏移量
      //   offset = offset + items.length - 1;
      // });
      // checkText = checkTextArry.join('');
      return hitStr.replace(/\r\n/g, '<br />').replace(/\r/g, '<br />').replace(/\n/g, '<br />');
    }
  }
});
